<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    class="voting-instructions-icon svg-icon"
  >
    <path
      class="st0"
      d="M73.8,256c0,8.8-7.2,16-16,16H16c-8.8,0-16-7.2-16-16s7.2-16,16-16h41.8C66.6,240,73.8,247.2,73.8,256z"
    />
    <path
      class="st0"
      d="M75,97.6c-6.2-6.2-6.2-16.4,0-22.6c6.2-6.3,16.4-6.3,22.6,0l29.5,29.5c6.2,6.2,6.2,16.4,0,22.6
	c-3.2,3.1-7.2,4.7-11.3,4.7c-4.1,0-8.2-1.6-11.3-4.7L75,97.6z"
    />
    <path
      class="st0"
      d="M192,448h128v26.7c0,20.5-16.8,37.3-37.3,37.3h-53.3c-17.9,0-37.3-13.7-37.3-43.5V448H192z"
    />
    <path
      class="st0"
      d="M350.1,140c-35-28.4-81.1-39.5-126.1-29.9c-56.5,11.7-102.4,57.8-114.1,114.3c-12,58,9.8,115.6,56.3,150.8
	c12.6,9.4,21.3,23.9,24.3,40.8v0.2c0.4-0.2,1.1-0.2,1.5-0.2h128c0.4,0,0.6,0,1.1,0.2V416c3-16.2,12.6-31.2,27.3-42.7
	c36.1-28.6,57-71.2,57-117.3C405.3,210.8,385.3,168.5,350.1,140z M336,266.7c-8.8,0-16-7.3-16-16c0-32.4-26.2-58.7-58.7-58.7
	c-8.7,0-16-7.2-16-16s7.3-16,16-16c49.9,0,90.7,40.8,90.7,90.7C352,259.4,344.8,266.7,336,266.7z"
    />
    <path
      class="st0"
      d="M512,256c0,8.8-7.2,16-16,16h-41.8c-8.8,0-16-7.2-16-16s7.2-16,16-16H496C504.8,240,512,247.2,512,256z"
    />
    <path
      class="st0"
      d="M384.9,127.1c-6.2-6.3-6.2-16.4,0-22.6L414.4,75c6.2-6.3,16.4-6.3,22.6,0c6.3,6.2,6.3,16.4,0,22.6l-29.5,29.5
	c-3.1,3.1-7.2,4.7-11.3,4.7C392.1,131.8,388,130.3,384.9,127.1z"
    />
    <path
      class="st0"
      d="M437,414.4c6.3,6.2,6.3,16.4,0,22.6c-3.1,3.1-7.2,4.7-11.3,4.7c-4.1,0-8.2-1.6-11.3-4.7l-29.5-29.5
	c-6.2-6.2-6.2-16.4,0-22.6c6.3-6.2,16.4-6.2,22.6,0L437,414.4z"
    />
    <path
      class="st0"
      d="M240,57.8V16c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16v41.8c0,8.8-7.2,16-16,16S240,66.6,240,57.8z"
    />
    <path
      class="st0"
      d="M127.2,384.8c6.2,6.2,6.2,16.4,0,22.6L97.6,437c-3.1,3.1-7.2,4.7-11.3,4.7c-4.1,0-8.2-1.6-11.3-4.7
	c-6.2-6.2-6.2-16.4,0-22.6l29.5-29.5C110.8,378.6,120.9,378.6,127.2,384.8z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconVotingInstructions"
};
</script>

<style scoped>
.voting-instructions-icon {
  fill-rule: evenodd;
  clip-rule: evenodd;
  stroke-linejoin: round;
  stroke-miterlimit: 2;
  height: 1.4em;
  width: 1.2em;
  padding-bottom: 0.1em;
}
.st0 {
  fill: #ffffff;
}
</style>
